import * as types from './actionTypes';

const initialState = {
  avatarLoading: false,
  avatarId: null,
  skinToneHex: null,
  forceBroadcast: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_AVATAR_LOADING: {
      return {...state, avatarLoading: action.payload};
    }
    case types.SET_AVATAR_DATA: {
      return {
        ...state,
        avatarId: action.avatarId,
        skinToneHex: action.skinToneHex,
      };
    }
    case types.FORCE_BROADCAST: {
      return {...state, forceBroadcast: action.payload};
    }
    default:
      return state;
  }
};

export default reducer;
